export const HOST = '';
export const DOMAIN = '.podzamenu.ru';
export const CRM_HOST = 'https://crm.podzamenu.ru';
export const STATIC_PATH = '/img';
export const RECAPTCHA_SITE_KEY = '6LdS_fUpAAAAANMGnwuBi8KXtLA0TBJP_V0dW83X';
export const API_URL = '';
